<span class="page-header__icon"
      cy-basketBagBtn
      [attr.aria-label]="'Basket quantity %' | translate : basket?.qty"
      [attr.qty-bullet]="basket?.qty || undefined">
    <i class="icon-basket"
       aria-hidden="true"></i>
</span>
